import moment from "moment";
import { useEffect, useState } from "react";

import { getActiveTime } from "../../lib/discordQueries";
import { ActiveTimeForMessaging, GroupBy } from "../../lib/discordTypes";

const defaultTimeFormat = "MM/DD/YY";

/**
 * Loads avarage Discord messages grouped by day or hour
 * @param startTime start of period
 * @param endTime end of period
 * @param groupBy "daily" or "hourly"
 * @returns
 * loading: wether thehook is loading
 * data: a list of avg messages with its time_period
 */
function useActiveTimeCard(
  startTime: string,
  endTime: string,
  groupBy: GroupBy
) {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<ActiveTimeForMessaging[]>([]);

  /**
   * Loads average number of messages in Discord grouped by day of week or hour of the day
   */
  const loadAvgMessages = async () => {
    setLoading(true);
    const params = {
      startTime: moment(startTime).format(defaultTimeFormat),
      endTime: moment(endTime).format(defaultTimeFormat),
    };
    let dataResponse = await getActiveTime(
      params.startTime,
      params.endTime,
      groupBy
    );

    // Set avg as a whole number
    dataResponse = dataResponse.map((item) => {
      return { ...item, avg: Math.round(item.avg) };
    });

    if (dataResponse.length && groupBy === GroupBy.Daily) {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const arr: ActiveTimeForMessaging[] = [];
      days.map((day) => {
        let dayRecord = dataResponse.find((item) => {
          return item.time_period.toLowerCase().includes(day.toLowerCase());
        });
        const time_period = dayRecord ? dayRecord.time_period.slice(0, 3) : "";

        if (dayRecord !== undefined) arr.push({ ...dayRecord, time_period });
        return;
      });
      setData(arr);
    }

    if (dataResponse.length && groupBy === GroupBy.Hourly) {
      setData(dataResponse);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadAvgMessages();
  }, [startTime, endTime, groupBy]);

  return {
    loading,
    data,
  };
}

export default useActiveTimeCard;
